import React from "react";
import { Link } from "react-router-dom";

export default function TenantAdminPlaceholderPage({ title, description }) {
  return (
    <div className="min-h-screen bg-slate-50 p-4 md:p-6">
      <div className="mx-auto max-w-6xl">
        <div className="mb-4 flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-slate-900">{title}</h1>
            <p className="text-sm text-slate-600">{description}</p>
          </div>
          <Link
            to="/tenant-admin"
            className="rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-700 hover:bg-slate-50"
          >
            Terug naar TenantAdmin hub
          </Link>
        </div>

        <div className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm">
          <p className="text-sm text-slate-700">
            Deze sectie is als placeholder toegevoegd. In de volgende iteratie koppelen we hier de echte
            beheerfunctionaliteit.
          </p>
        </div>
      </div>
    </div>
  );
}
